module.exports = __webpack_public_path__ + "static/media/equivalentDocument.da7a3761.svg";